
<script>

export default {
  name: 'Druid',
  components: {
  },
  data () {
    return {
      src: process.env.VUE_APP_BASE_API + '/druid/login.html',
      loading: true
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted: function () {
    const that = this
    window.open(that.src, '_blank')
  },
  methods: {
  }
}
</script>
